import Layout from "../components/layout";

import "./cv-page.css";

const CVPage = () => (
  <>
    <Layout>
      <p>
        Born 1991 in New Jersey, USA
        <br />
        Lives and works in Pittsburgh, PA
      </p>
      <h2>Education</h2>
      <ul>
        <li>
          2024 – Drawing Year Certificate, Grand Central Atelier, Queens, NY
        </li>
        <li>
          2014 – BA in Art History, The New School Schools of Public Engagement,
          New York, NY
        </li>
      </ul>
      <h2>Teaching Experience</h2>
      <ul>
        <li>2026 – Art Instructor, Clinton Hill Middle School, Brooklyn, NY</li>
        <li>2024 to 2026 – Art Teacher, The Art Studio NY, New York, NY</li>
      </ul>
      <h2>Residencies/Fellowships</h2>
      <ul>
        <li>
          2024 – The Met Copyist Program, The Metropolitan Museum of Art, New
          York, NY
        </li>
      </ul>
      <h2>Exhibition History</h2>
      <ul>
        <li>
          2026 - <em>Cabinet of Curiosities</em> (group), The Nicolaysen Art
          Museum, Casper, WY
        </li>
        <li>
          2026 - <em>Summer/Fall 2027 Show</em> (group), Salem Cat Museum,
          Salem, MA
        </li>
        <li>
          2026 - <em>Lore</em> (group), The Compass Gallery, Provo, UT
        </li>
        <li>
          2026 - <em>The Other Art Fair</em> (fair), Brooklyn, NY
        </li>
        <li>
          2026 - <em>Every Woman Biennial</em> (group), Pen + Brush Gallery, New
          York, NY
        </li>
        <li>
          2025 – <em>Solstice</em> (group), Torrents Art, Missoula, MT
        </li>
        <li>
          2025 –{" "}
          <em>
            In the Gallery of Shadows the Paint Still Bleeds and Demons Dance
          </em>{" "}
          (group), Gallery 14C, Jersey City, NJ
        </li>
        <li>
          2025 – <em>In the Belly of the Whale</em> (group), Whale Art
          Collective, Brooklyn, NY
        </li>
        <li>
          2024 – <em>2024 Grand Central Atelier Spring Student Show</em>{" "}
          (group), Salmagundi Club, New York, NY
        </li>
        <li>
          2023 – <em>2023 Juried Selection Exhibition</em> (group), Phyllis
          Harriman Mason Gallery, Art Students League, New York, NY
        </li>
        <li>
          2023 – <em>Student Salons 2023</em> (group), Phyllis Harriman Mason
          Gallery, Art Students League, New York, NY
        </li>
      </ul>
      <h2>Collections</h2>
      <ul>
        <li>Alvin Hall, New York, NY</li>
        <li>Constance Wu, New York, NY</li>
      </ul>
    </Layout>
  </>
);

export default CVPage;
